import { Component, forwardRef, Input } from '@angular/core'
import { FormControlValueAccessor } from '@mistergreen/shared/angular-directives/abstract-value-accessor'
import { NG_ASYNC_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms'
import { DealOption } from 'modules/deals/utilities/deal-types'
import { LocaleService } from 'framework/locale/services/locale.service'

@Component({
    selector: 'mg-configuration-option-select-advanced',
    templateUrl: './configuration-option-select-advanced.component.html',
    styleUrls: ['./configuration-option-select-advanced.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ConfigurationOptionSelectAdvancedComponent),
            multi: true,
        },
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ConfigurationOptionSelectAdvancedComponent),
            multi: true,
        },
    ],
})
export class ConfigurationOptionSelectAdvancedComponent extends FormControlValueAccessor {
    @Input()
    configurationOption: DealOption

    language: string

    constructor(public localeService: LocaleService) {
        super()
    }

    get options(): { id: string; label?: string }[] | boolean[] {
        if (this.configurationOption.__typename === 'SelectableDealOption') {
            return this.configurationOption.selectableValues
        } else {
            return [true, false]
        }
    }

    get isYesNoQuestion() {
        return this.configurationOption.__typename === 'BooleanDealOption'
    }

    async validate(): Promise<ValidationErrors | null> {
        return (this.value || this.value === false) && this.options ? null : { value: 'not set' }
    }
}
